import { SnackbarProvider } from "notistack";
import { NotificationItem } from "../NotificationItem";

const NotificationsWrapper = ({ children }: React.PropsWithChildren): React.ReactNode => {
	return (
		<SnackbarProvider
			maxSnack={3}
			autoHideDuration={3000}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			Components={{
				default: NotificationItem,
				info: NotificationItem,
				success: NotificationItem,
				warning: NotificationItem,
				error: NotificationItem,
			}}
		>
			{children}
		</SnackbarProvider>
	);
};

export { NotificationsWrapper };
